import React from 'react';
import { View, Text } from '@react-pdf/renderer';
import { type, colors, space } from '../theme';
import Eyebrow from '../components/Eyebrow';
import Chip from '../components/Chip';
import SectionTitle from '../components/SectionTitle';

const FIT_VARIANT = { green: 'success', amber: 'warning', red: 'danger' };

const Bulleted = ({ items }) => (
  <View style={{ marginTop: space.sm }}>
    {items.map((item, i) => (
      <View key={i} style={{ flexDirection: 'row', marginTop: i === 0 ? 0 : 6 }}>
        <View style={{
          width: 3, height: 3, borderRadius: 1.5,
          backgroundColor: colors.muted, marginRight: space.sm, marginTop: 6,
        }} />
        <Text style={[type.body, { color: colors.ink, flex: 1 }]}>{item}</Text>
      </View>
    ))}
  </View>
);

// Matches the in-app "Prospect Profile" block. Title + Pain Points/Buying
// Signals two-col stay together via wrap={false}; Decision Criteria and
// Target Market Fit flow below and can break naturally.
const ProspectProfileSection = ({ report }) => {
  const p = report.profile;
  if (!p) return null;
  const painPoints = p.painPoints || [];
  const buyingSignals = p.buyingSignals || [];
  const decisionCriteria = p.decisionCriteria || [];

  return (
    <View>
      <View wrap={false}>
        <SectionTitle>Prospect Profile</SectionTitle>
        <View style={{ flexDirection: 'row', gap: space.lg }}>
          <View style={{ flex: 1 }}>
            {painPoints.length > 0 && (
              <>
                <Eyebrow>Pain Points</Eyebrow>
                <Bulleted items={painPoints} />
              </>
            )}
          </View>
          <View style={{ flex: 1 }}>
            {buyingSignals.length > 0 && (
              <>
                <Eyebrow>Buying Signals</Eyebrow>
                <Bulleted items={buyingSignals} />
              </>
            )}
          </View>
        </View>
      </View>

      {decisionCriteria.length > 0 && (
        <View wrap={false} style={{ marginTop: space.md }}>
          <Eyebrow>Decision Criteria</Eyebrow>
          <Bulleted items={decisionCriteria} />
        </View>
      )}

      {p.targetMarketFit && (
        <View wrap={false} style={{
          marginTop: space.md,
          backgroundColor: colors.cardBg,
          borderRadius: 6,
          padding: space.md,
        }}>
          <View style={{ flexDirection: 'row', alignItems: 'center', gap: 8 }}>
            <Eyebrow>Target Market Fit</Eyebrow>
            {p.targetMarketFit.level && (
              <Chip variant={FIT_VARIANT[p.targetMarketFit.color] || 'neutral'}>
                {p.targetMarketFit.level}
              </Chip>
            )}
          </View>
          {p.targetMarketFit.reasoning && (
            <Text style={[type.body, { color: colors.inkSoft, marginTop: space.sm }]}>
              {p.targetMarketFit.reasoning}
            </Text>
          )}
        </View>
      )}
    </View>
  );
};

export default ProspectProfileSection;
